/* unplugin-vue-components disabled */import { render } from "./reset-password-modal.vue?vue&type=template&id=413fe583&scoped=true"
import script from "./reset-password-modal.vue?vue&type=script&lang=js"
export * from "./reset-password-modal.vue?vue&type=script&lang=js"

import "./reset-password-modal.vue?vue&type=style&index=0&id=413fe583&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-413fe583"],['__file',"src/pages/tenants/reset-password-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "413fe583"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('413fe583', __exports__)) {
    api.reload('413fe583', __exports__)
  }
  
  module.hot.accept("./reset-password-modal.vue?vue&type=template&id=413fe583&scoped=true", () => {
    api.rerender('413fe583', render)
  })

}


export default __exports__